export function serializeAs<T extends object>(originClass: new () => T, d: object): T {
  const obj = new originClass() as Record<string, unknown>
  const data = { ...d } as Record<string, unknown>
  for (const key in data) {
    const templateValue = obj[key]
    let value = data[key]
    if (typeof templateValue === 'string' && typeof value !== 'string') {
      if (value instanceof Date) {
        value = value.toISOString()
      } else if (value === null) {
        value = ''
      } else if (typeof value === 'object') {
        value = JSON.stringify(value)
      }
      // undefined has no toString — legacy behavior leaves it undefined (JSON.stringify(undefined))
      value = value === undefined ? JSON.stringify(value) : String(value)
    } else if (typeof templateValue === 'number' && typeof value !== 'number') {
      value = parseFloat(String(value))
    } else if (typeof templateValue === 'object' && Array.isArray(templateValue) && value !== null && value !== undefined && !Array.isArray(value)) {
      value = [value]
    }
    data[key] = value
  }
  return data as T
}
